import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Signal,
  ViewChild,
  effect,
  inject,
} from '@angular/core';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';
import { getMinMaxDate } from '../../services/assessmentsHistory.functions';
import { AssessmentChartDataRow, AssessmentChartDataSets, SubTestChartDataSet } from '../../services/model';
import { BarChartBaseComponent } from '../bar-chart-base/bar-chart-base.component';
// import { Chart } from 'chart.js';

@Component({
  selector: 'app-arat-chart',
  standalone: true,
  imports: [],
  template: '<canvas style="width:100%" #canvas [id]="chartId">{{ chart }}</canvas>',
})
export class AratChartComponent extends BarChartBaseComponent implements AfterViewInit {
  @Input() data!: Array<AssessmentChartDataRow> | undefined;
  @Input() dataFull!: Signal<AssessmentChartDataSets | undefined>;
  @Input() chartId!: string;
  @Input() type!: 'bar' | 'line';
  @ViewChild('canvas') canvas!: ElementRef<any>;

  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private maxY = 19 * 3; // maximal mögliche Punktzahl ist bei 19 Fragen und 3 Punkten je Frage

  constructor() {
    super();

    effect(() => {
      this.dataFull();
      if (this.chart) {
        this.createChart();
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.createChart();
      this.cdr.detectChanges();
    }, 100);
  }

  createChart() {
    // jür jedes Datum eine Row
    const dataRows: Array<AssessmentChartDataRow> = this.data ?? [];
    // const labelData: Array<Date> = dataRows.map(row => new Date(new Date(row.dateIso).toDateString()));

    // const labelDataFull: Array<Date> = dataRows.map(row => new Date(row.dateIso));
    const datasetsObject: AssessmentChartDataSets = this.dataFull() ?? {};

    const { minDate, maxDate, labelDataFull } = getMinMaxDate(datasetsObject);

    const data = dataRows.map(row => {
      const grasp: SubTestChartDataSet = row.subDataSets.filter(set => set.subType === 'grasp')[0];
      const grip = row.subDataSets.filter(set => set.subType === 'grip')[0];
      const pinch = row.subDataSets.filter(set => set.subType === 'pinch')[0];
      const gross = row.subDataSets.filter(set => set.subType === 'gross')[0];
      return {
        x: new Date(new Date(row.dateIso).toDateString()),
        graspL: grasp.sumLeft,
        graspR: grasp.sumRight,
        gripL: grip.sumLeft,
        gripR: grip.sumRight,
        pinchL: pinch.sumLeft,
        pinchR: pinch.sumRight,
        grossL: gross.sumLeft,
        grossR: gross.sumRight,
        score: row.score,
        documentId: row.documentId,
        assessmentType: row.type,
      };
    });

    const datasets = [
      {
        stack: 'left',
        label: 'Grasp L',
        data: data,
        parsing: {
          yAxisKey: 'graspL',
        },

        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgb(75, 192, 192)',
      },
      {
        stack: 'left',
        label: 'Grip L',
        data: data,
        parsing: {
          yAxisKey: 'gripL',
        },

        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgb(54, 162, 235)',
      },

      {
        stack: 'left',
        label: 'Pinch L',
        data: data,
        parsing: {
          yAxisKey: 'pinchL',
        },

        backgroundColor: 'rgba(153, 102, 255, 0.6)',
        borderColor: 'rgb(153, 102, 255)',
      },
      {
        stack: 'left',
        label: 'Gross L',
        data: data,
        parsing: {
          yAxisKey: 'grossL',
        },

        backgroundColor: 'rgba(75, 102, 255, 0.6)',
        borderColor: 'rgb(153, 102, 255)',
      },
      {
        stack: 'right',
        label: 'Grasp R',
        data: data,
        parsing: {
          yAxisKey: 'graspR',
        },
        backgroundColor: 'rgba(255, 159, 64, 0.6)',
        borderColor: 'rgb(255, 159, 64)',
      },
      {
        stack: 'right',
        label: 'Grip R',
        data: data,
        parsing: {
          yAxisKey: 'gripR',
        },
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
        borderColor: 'rgb(255, 99, 132)',
      },

      {
        stack: 'right',
        label: 'Pinch R',
        data: data,
        parsing: {
          yAxisKey: 'pinchR',
        },
        backgroundColor: 'rgba(255, 205, 86, 0.6)',
        borderColor: 'rgb(255, 205, 86)',
      },
      {
        stack: 'right',
        label: 'Gross R',
        data: data,
        parsing: {
          yAxisKey: 'grossR',
        },
        backgroundColor: 'rgba(255, 55, 132, 0.6)',
        borderColor: 'rgb(255, 99, 132)',
      },
    ];

    if (this.chart) {
      this.chart.data = { labels: labelDataFull, datasets: datasets };
      this.chart.options.scales.x.min = minDate;
      this.chart.options.scales.x.max = maxDate;
      this.chart.update();
    } else {
      this.chart = new Chart(
        this.canvas.nativeElement,
        this.getChartConfig(datasets, minDate, maxDate, labelDataFull, false, this.maxY + 5)
      );
    }

    // this.chart = new Chart(this.canvas.nativeElement, {
    //   type: 'bar',
    //   data: {
    //     labels: labelDataFull,
    //     datasets: datasets,
    //   },
    //   options: {
    //     responsive: true,
    //     aspectRatio: 3,
    //     animation: {
    //       delay: 300,
    //     },
    //     layout: {
    //       // autoPadding:true
    //       padding: {
    //         left: 80,
    //         right: 30,
    //       },
    //     },
    //     scales: {
    //       y: {
    //         min: 0,
    //         max: this.maxY + 5,
    //         reverse: false,
    //         position: 'right',
    //         grid: {
    //           display: false,
    //         },
    //       },
    //       x: {
    //         // beginAtZero: true,
    //         grid: {
    //           display: true,
    //         },
    //         type: 'time',
    //         time: {
    //           tooltipFormat: 'DD.MM.YY',
    //           unit: 'day',
    //         },
    //         min: minDate,
    //         max: maxDate,

    //         // time: {
    //         //   unit: 'week',
    //         //   isoWeekday: true,
    //         //   displayFormats: {
    //         //     week: 'dd, DD.MM.YY',
    //         //   },
    //         // },
    //       },
    //     },
    //     plugins: {
    //       legend: {
    //         position: 'top',
    //       },
    //       datalabels: {
    //         // color: 'white',
    //         display: function (context) {
    //           // return context.dataset.data[context.dataIndex] > 15;
    //           return true;
    //         },
    //         font: {
    //           // weight: 'bold',
    //           size: 8,
    //         },
    //         // formatter: Math.round,
    //         formatter: (val, context) => {
    //           const parsing = context?.dataset?.parsing as any;
    //           const key = parsing.yAxisKey;
    //           // console.log('val ', { val, context });
    //           console.log(
    //             'key ' +
    //               key +
    //               ' backgroundColor: "' +
    //               context.dataset.backgroundColor +
    //               '", borderColor: "' +
    //               context.dataset.borderColor +
    //               '"',
    //             { val, context }
    //           );
    //           return val[key];
    //         },
    //       },
    //     },
    //   },
    //   plugins: [this.customCanvasBackgroundColor, ChartDataLabels],
    // });
  }
}
